import axios from 'axios'
import {authorizedAPIs} from '@/api'

export default class WebAPI {

  constructor ({baseURL, sessionFunc}) {
    this.baseURL = baseURL
    this.session = sessionFunc
  }

  __post ({extensionURL, payload, addSession, config = {}}) {
    let session = addSession ? this.__getSession() : undefined
    return authorizedAPIs.post(`${this.baseURL + extensionURL}`, payload, {...config, ...session}).then(resp => {
      return resp.data
    })
  }

  __get ({query, extensionURL, addSession}) {
    let queryString = query ? this.__parseDataforQuery(query) : ''
    let session = addSession ? {headers: this.__getSession()} : undefined
    return authorizedAPIs.get(`${this.baseURL + extensionURL + queryString}`, session)
  }

  __delete ({extensionURL, addSession}) {
    let session = addSession ? { headers: this.__getSession() } : undefined
    return authorizedAPIs.delete(`${this.baseURL + extensionURL}`, session)
  }

  __geturl (url) {
    return authorizedAPIs.get(url)
  }

  __parseDataforQuery (dataToSend) {
    let filteredList = Object.keys(dataToSend).filter(k => dataToSend[k])
    if (filteredList.length > 0) {
      return '?' + filteredList.map(k => {
        let value = dataToSend[k]
        let front = encodeURIComponent(k) + '='
        if ((typeof value) === 'string') {
          return front + value
        } else {
          return front + JSON.stringify(value)
        }
      }).join('&')
    } else {
      return ''
    }
  }

  __getSession () {
    return this.session()
  }
}



// WEBPACK FOOTER //
// ./src/app/clientLogic/apis/WebAPI.js